import { returnsDefaultWeightByZoneSchema } from "@redotech/redo-fulfillment-rate-table-common/rate-table";
import * as z from "zod";

export const getDefaultRateTables = {
  name: "getDefaultRateTables" as const,
  input: z.object({}),
  output: z.object({ rateTables: z.array(returnsDefaultWeightByZoneSchema) }),
};
